import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MomentModule } from 'ngx-moment';
import { DocketRolloverModel } from '../../../shared/models/docket-rollover.model';
import { HlCurrencyPipe } from '../../../shared/pipes/hl-currency.pipe';
import { ConfigService } from '../../../shared/services/config.service';
import { DocketService } from '../../../shared/services/docket.service';
import { ChargeDisplayComponent } from '../charge-display/charge-display.component';

@Component({
  selector: 'app-batch-rollover-dialog',
  templateUrl: './batch-rollover-dialog.component.html',
  styleUrls: ['./batch-rollover-dialog.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatExpansionModule,
    MomentModule,
    HlCurrencyPipe,
    MatTooltipModule,
    MatIconModule,
    ChargeDisplayComponent
  ],
  providers: [DocketService]
})
export class BatchRolloverDialogComponent implements OnInit {
  loading = true;
  rolloverData: RolloverReportItem[] = [];
  displayedColumns: string[] = ['item_code', 'on_hire', 'off_hire', 'charge'];

  dateFormat = ConfigService.dates.shortDateTimeFormat;

  constructor(
    public dialogRef: MatDialogRef<BatchRolloverDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { docketIds: number[] },
    private docketService: DocketService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadRolloverData();
  }

  loadRolloverData(): void {
    this.loading = true;
    this.docketService.rolloverDockets(this.data.docketIds).subscribe({
      next: (data) => {
        this.rolloverData = data.map((docket) =>
          this.mapDocketToRolloverReportItem(docket)
        );
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading rollover data:', error);
        this.loading = false;
      }
    });
  }

  mapDocketToRolloverReportItem(
    docket: DocketRolloverModel
  ): RolloverReportItem {
    const icon = docket.errorCalculatingPrice
      ? 'error'
      : docket.hasHardCodedPrice
        ? 'warning'
        : 'success';
    const message = docket.errorCalculatingPrice
      ? 'Error calculating price for some items'
      : docket.hasHardCodedPrice
        ? 'Has fixed price item(s)'
        : 'Success';
    return {
      ...docket,
      icon,
      message
    };
  }
  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    // Close this dialog
    this.dialogRef.close(this.data.docketIds);
  }

  getTotalItems(): number {
    return this.rolloverData.reduce(
      (total, docket) => total + docket.items.length,
      0
    );
  }
}

interface RolloverReportItem extends DocketRolloverModel {
  icon: 'error' | 'warning' | 'success';
  message: string;
}
